import React, { useEffect, useState } from 'react';
import './TermsConditions.css';

const TermsConditions = () => {
  const [isVisible, setIsVisible] = useState(false);
  const lastUpdated = "January 5, 2026"; // Fixed date from your provided terms

  useEffect(() => {
    setIsVisible(true);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`TermsConditions-container ${isVisible ? 'visible' : ''}`}>
      <div className="TermsConditions-content">
        <header className="TermsConditions-header">
          <div className="TermsConditions-header-decoration"></div>
          <h1>Terms and Conditions</h1>
          <p className="TermsConditions-last-updated">Last updated: {lastUpdated}</p>
          <p className="TermsConditions-subtitle">EZRaider US<br />ezraiderus.com</p>
        </header>

        <div className="TermsConditions-sections">
          {/* 1. Website Use */}
          <section className="TermsConditions-section">
            <div className="TermsConditions-section-header">
              <div className="TermsConditions-section-number">1</div>
              <h2>Website Use</h2>
            </div>
            <div className="TermsConditions-section-content">
              <p>
                This website is provided for general informational purposes and to allow visitors to contact EZRaider US.
              </p>
              <p>
                By using this website, you agree to use it in a lawful and reasonable manner.
              </p>
            </div>
          </section>

          {/* 2. Communications */}
          <section className="TermsConditions-section">
            <div className="TermsConditions-section-header">
              <div className="TermsConditions-section-number">2</div>
              <h2>Communications</h2>
            </div>
            <div className="TermsConditions-section-content">
              <p>
                If you choose to contact us or submit your contact information through this website, you consent to receive communications from EZRaider US related to your inquiry.
              </p>
              <p>
                Communications may be provided by phone, email, or SMS. Message frequency may vary. Message and data rates may apply. Consent is not a condition of purchase.
              </p>
            </div>
          </section>

          {/* 3. Information */}
          <section className="TermsConditions-section">
            <div className="TermsConditions-section-header">
              <div className="TermsConditions-section-number">3</div>
              <h2>Information</h2>
            </div>
            <div className="TermsConditions-section-content">
              <p>
                Information on this website is provided as is and may be updated or changed at any time.
              </p>
            </div>
          </section>

          {/* 4. Third-Party References */}
          <section className="TermsConditions-section">
            <div className="TermsConditions-section-header">
              <div className="TermsConditions-section-number">4</div>
              <h2>Third-Party References</h2>
            </div>
            <div className="TermsConditions-section-content">
              <p>
                This website may reference or direct you to third-party resources. EZRaider US is not responsible for third-party content or practices.
              </p>
            </div>
          </section>

          {/* 5. Updates */}
          <section className="TermsConditions-section">
            <div className="TermsConditions-section-header">
              <div className="TermsConditions-section-number">5</div>
              <h2>Updates</h2>
            </div>
            <div className="TermsConditions-section-content">
              <p>
                These Terms and Conditions may be updated from time to time. Continued use of the website indicates acceptance of the current version.
              </p>
            </div>
          </section>
        </div>

        <footer className="TermsConditions-footer">
          <p>© 2026 EZRaider US. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default TermsConditions;